import { UploadImage } from '@components/UploadImage'
import { UploadImageFieldProps } from './interface'

export function UploadImageField(props: UploadImageFieldProps) {
  return <UploadImage {...props} />
}
